import React, { Suspense, useState, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { Link } from 'react-router-dom';
import { OrbitControls, Float, useGLTF } from '@react-three/drei';
import { motion, AnimatePresence } from 'framer-motion';
import '../pages/css/Home.css';
import HomeHeader from '../pages/components/HomeHeader';
import ClientReviews from '../pages/components/ClientReviews';
import BlogSection from '../pages/components/BlogSection';
import homebg from '../images/homebg.png';
import whoImg from '../images/whosection.jpg';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFour from '../images/Google.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTSeven from '../images/JPMorgan.png';
import cTEight from '../images/Goldman.jpg';
import servicebg from '../images/testimonial-bg.png';
import industries01 from '../images/industries1.gif';
import industries02 from '../images/industries2.gif';
import industries03 from '../images/industries3.gif';
import industries04 from '../images/industries4.gif';
import industries05 from '../images/industries5.gif';
import industries06 from '../images/industries6.gif';
import techStack from '../images/tech-stack.png';
import industries07 from '../images/industries7.gif';
import downSection from '../images/downSection.jpg';
import cs1 from '../images/cs1.png';
import cs2 from '../images/cs2.png';
import cs3 from '../images/cs3.png';
import cs4 from '../images/cs4.png';
import cs5 from '../images/cs5.png';
import cs6 from '../images/cs6.png';
import cs7 from '../images/cs7.png';
import cs8 from '../images/cs8.png';
import cs9 from '../images/cs9.png';
import cs22 from '../images/cs22.png';
import review1 from '../images/review1.jpg';
import review2 from '../images/review2.jpg';
import review3 from '../images/review3.jpg';
import review4 from '../images/review4.jpg';
import review5 from '../images/review5.jpg';
import review6 from '../images/review6.jpg';
import review7 from '../images/review7.jpg';
import review8 from '../images/review8.jpg';
import { FaLaptopCode, FaBrain, FaMobileAlt, FaBuilding, FaBoxOpen, FaMobile, FaArrowLeft, FaArrowRight, FaRocket, FaTools, FaUsers, FaChartLine, FaCheckCircle } from 'react-icons/fa';
import { GiRobotAntennas } from 'react-icons/gi';
import { MdOutlineRocketLaunch } from 'react-icons/md';

// Different GLB Models (You must have these in /public)
function LaptopModel(props) {
    const gltf = useGLTF('/sci-fi__laptop.glb');
    return <primitive object={gltf.scene} {...props} />;
}

function PhoneModel(props) {
    const gltf = useGLTF('/tech_noir__cyberpunk_space.glb'); // Example, you can change this
    return <primitive object={gltf.scene} {...props} />;
}

function RobotModel(props) {
    const gltf = useGLTF('/sci-fi__laptop.glb'); // Example
    return <primitive object={gltf.scene} {...props} />;
}

function DroneModel(props) {
    const gltf = useGLTF('/sci-fi__laptop.glb'); // Example
    return <primitive object={gltf.scene} {...props} />;
}

// All carousel content here:


const services = [
    {
        Icon: FaLaptopCode,
        title: "Custom Software Development",
        desc: "We craft bespoke software solutions tailored to your business needs, combining intuitive design, robust architecture, and Azure cloud integration. From backend systems to full-scale platforms, we ensure scalability, data security, seamless API connectivity, and performance optimization to help you build, automate, and grow with confidence.",
        link: "/custom-software-development"
    },
    {
        Icon: FaBrain,
        title: "Artificial Intelligence",
        desc: "We offer advanced solutions that harness the power of machine learning, artificial intelligence (AI), and data analytics to optimize business processes, predict trends, and unlock actionable insights. By leveraging cutting-edge technologies",
        link: "/artificial-intelligence"
    },
    {
        Icon: GiRobotAntennas,
        title: "AI Agent Development",
        desc: "Building intelligent, adaptive AI agents designed to solve complex problems and enhance user experiences. From conversational bots to advanced machine learning models, we create cutting-edge solutions that empower businesses and optimize workflows across industries",
        link: "/ai-agent-development"
    },
    {
        Icon: MdOutlineRocketLaunch,
        title: "MVP Development",
        desc: "Turning visionary ideas into actionable prototypes with lean, scalable MVPs for faster market validation and growth.We transform bold ideas into reality with laser-focused MVPs—crafted to test core assumptions, gather user feedback, and gain traction fast. Because in startups, speed and focus win.",
        link: "/minimum-viable-product"
    },
    {
        Icon: FaMobileAlt,
        title: "Website & Mobile App Development",
        desc: "Crafting seamless, high-performance digital products tailored to your business goals. From responsive websites to scalable mobile apps, we turn ideas into intuitive, user-driven experienced across platforms.",
        link: "/website-and-app-development"
    },
    {
        Icon: FaBuilding,
        title: "Enterprise Web Development",
        desc: "Delivering robust, scalable, and secure web solutions designed to drive your enterprise forward. From complex web applications to custom enterprise portals, we build digital infrastructures that enhance performance and accelerate growthacross your organization.",
        link: "/enterprise-web-development"
    },
    {
        Icon: FaBoxOpen,
        title: "Product Development",
        desc: "We specialize in delivering end-to-end product development solutions. From conceptualization and design to development and deployment, we craft tailored digital products that align with your business objectives. Whether you're building an engaging website or a high-performance",
        link: "/product-development"
    },
    {
        Icon: FaMobile,
        title: "Blockchain",
        desc: "We design and develop secure, decentralized blockchain applications tailored to your business goals. From smart contract engineering to scalable dApps and Web3 integrations, our solutions empower transparency, automation, and trust.",
        link: "/blockchain-development"
    },
];

function Home() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const [counters, setCounters] = useState([0, 0, 0, 0]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCounters(prev =>
                prev.map((val, idx) =>
                    val < stats[idx].value ? val + 5 : val
                )
            );
        }, 50);
        return () => clearInterval(interval);
    }, []);


    const tabs = [
        "Fintech & Insurtech", "Media & Communications", "Healthcare", "Retail & E-Commerce", "Entertainment & Gaming", "Logistics", "Real Estate & Construction"
    ];

    const tabContents = [
        {
            title: "Innovate and secure your global financial operations with Peregrinee’s specialized offshore software solutions for Fintech and Insurtech industries.",
            text: "Peregrinee specializes in offshore software solutions for the Fintech and Insurtech industries, enabling financial institutions and insurance providers to digitally innovate securely and rapidly. Our offshore teams develop customized financial technology applications, secure digital wallets, blockchain-based solutions, automated claim processing systems, and advanced risk management tools. This enables our clients to deliver seamless digital financial services that comply with international regulatory standards.",
            img: industries01
        },
        {
            title: "Engage global audiences with Peregrinee’s immersive and interactive offshore entertainment and gaming solutions designed to captivate and retain users.",
            text: "Our offshore software development services for the Media & Communications industry are designed to enhance content delivery, streamline communication processes, and increase audience engagement. Peregrinee provides innovative digital solutions such as content management systems, media analytics platforms, and integrated digital marketing tools, empowering media organizations to effectively manage content across diverse digital channels and deliver targeted communication that resonates globally.",
            img: industries02
        },
        {
            title: "Accelerate digital innovation in healthcare with Peregrinee’s secure and scalable offshore software solutions built to enhance patient care, operational efficiency, and regulatory compliance.",
            text: "Peregrinee’s offshore development expertise empowers healthcare organizations to modernize their digital infrastructure, streamline clinical workflows, and deliver patient-centric care. From secure telehealth platforms and electronic health records (EHR) to AI-driven diagnostics and hospital management systems, we build compliant, data-driven solutions that support better outcomes, reduce operational friction, and ensure full alignment with global health standards and privacy regulations.",
            img: industries03
        },
        {
            title: "Expand your global retail and e-commerce presence with Peregrinee’s tailored offshore software solutions designed to optimize customer experiences and operational efficiency.",
            text: "Peregrinee helps global retail and e-commerce businesses expand their digital presence and enhance customer experiences through robust offshore software development. Our specialized solutions include scalable e-commerce platforms, sophisticated inventory management systems, customer relationship management (CRM) tools, and personalized digital marketing automation systems. These tools enable businesses to effectively engage customers, increase conversions, and optimize global supply chain operations.",
            img: industries04
        },
        {
            title: "Deliver unforgettable digital experiences with Peregrinee’s offshore development solutions for immersive gaming, interactive media, and user engagement at scale.",
            text: "Peregrinee brings deep technical expertise and creative innovation to the entertainment and gaming industry, delivering high-performance offshore solutions that captivate audiences and drive engagement. We develop immersive games, scalable media platforms, and dynamic content systems designed for seamless cross-platform experiences. Our approach integrates advanced graphics, real-time interactivity, and gamification strategies to boost user retention and monetization. With global delivery capabilities, we help entertainment brands expand rapidly into new markets and stay ahead of digital trends.",
            img: industries05
        },
        {
            title: "Optimize supply chains and transportation networks with Peregrinee’s agile, data-driven offshore logistics software solutions.",
            text: "Peregrinee empowers logistics and supply chain enterprises with advanced offshore software development services designed to boost efficiency, visibility, and control. We build custom logistics platforms, fleet management systems, real-time tracking solutions, warehouse automation tools, and predictive analytics dashboards. Our solutions help businesses reduce operational costs, improve delivery accuracy, and adapt quickly to global logistics challenges—enhancing end-to-end supply chain performance across industries.",
            img: industries06
        },
        {
            title: "Streamline property management and construction workflows with Peregrinee’s scalable, secure offshore software solutions.",
            text: "Peregrinee delivers advanced offshore software development services to the real estate and construction industries, enabling seamless project management, property tracking, and client engagement. Our solutions include construction management platforms, BIM integration tools, real estate CRM systems, and smart contract applications. By leveraging these digital tools, businesses can improve collaboration, reduce project delays, optimize resource allocation, and enhance transparency across the project lifecycle, driving efficiency and growth in a competitive market.",
            img: industries07
        }
    ];

    const reviews = [
        { src: review1, link: 'https://www.google.com/search?gs_ssp=eJzj4tVP1zc0rDQ1T7fILjM1YLRSNagwTjQwMjc3NTS3NEgxSzJOsQIKGZsnWxqZmCWZGxokp6SmeHEVpBalphdl5qWmAgBJUhLJ&q=peregrinee&oq=&gs_lcrp=EgZjaHJvbWUqDwgAEC4YJxivARjHARjqAjIPCAAQLhgnGK8BGMcBGOoCMgkIARAjGCcY6gIyCQgCECMYJxjqAjIJCAMQIxgnGOoCMgkIBBAuGCcY6gIyCQgFECMYJxjqAjIJCAYQIxgnGOoCMgkIBxAjGCcY6gLSAQ0yNzQ1ODY0NjJqMGo3qAIIsAIB8QVSfzgjVnKB2PEFUn84I1Zygdg&sourceid=chrome&ie=UTF-8#lrd=0x3a027751790d6b3d:0x337c9246b710cded,1,,,,' },
        { src: review2, link: 'https://builtin.com/' },
        { src: review3, link: 'https://sell.g2.com/' },
        { src: review4, link: 'https://techbehemoths.com/company/peregrinee' },
        { src: review5, link: 'https://www.goodfirms.co/company/peregrinee' },
        { src: review6, link: 'https://clutch.co/profile/peregrinee#reviews' },
        { src: review7, link: 'https://www.designrush.com/agency/profile/peregrinee' },
        { src: review8, link: 'https://yourstory.com/companies/peregrinee' },
    ];

    const features = [
        {
            id: 1,
            image: cs1,
            alt: "Left",
            title: "CoreSync ERP",
            description: "Custom web development for clients in various industries for CoreSync ERP",
            link: "/coresync-erp",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        {
            id: 2,
            image: cs2,
            alt: "Center",
            title: "PlayMind",
            description: "Tailored websites for e-commerce businesses for PlayMind.",
            link: "/play-mind",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 3,
            image: cs3,
            alt: "Right",
            title: "UXGenie",
            description: "UI/UX design for UXGenie AI.",
            link: "/uxgenie",
            animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        },
        // Repeated to make 9 items
        {
            id: 4,
            image: cs4,
            alt: "Left",
            title: "RetailNova",
            description: "AI-powered analytics platform for RetailNova",
            link: "/retailnova",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        {
            id: 5,
            image: cs5,
            alt: "Center",
            title: "FinSightX",
            description: "Banking website for FinSightX.",
            link: "/finsightx",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 6,
            image: cs6,
            alt: "Right",
            title: "GamerGrid AI",
            description: "Gaming and reward app GamerGrid AI.",
            link: "/gamergrid",
            animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        },
        {
            id: 7,
            image: cs7,
            alt: "Left",
            title: "MediCore ERP",
            description: "Wellness platform MediCore ERP.",
            link: "/medicore-erp",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        // {
        //     id: 8,
        //     image: cs8,
        //     alt: "Center",
        //     title: "EduMinds AI",
        //     description: "Custom AI algorithms & Learning management system for EduMinds AI.",
        //     link: "/edumind",
        //     animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        // },
        // {
        //     id: 9,
        //     image: cs9,
        //     alt: "Right",
        //     title: "Rementeapp",
        //     description: "Remente Self Care Wellbeing.",
        //     link: "/remente",
        //     animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        // },
        {
            id: 8,
            image: cs22,
            alt: "Blue Box Media",
            title: "Blue Box Media",
            description: "Influencer marketing agency growth & outreach pipeline system.",
            link: "/bluebox-media",
            animation: {
                initial: { opacity: 0, y: 50 },
                animate: { opacity: 1, y: 0 },
                delay: 0.1
            }
        },
    ];

    const stats = [
        { value: 350, label: "Clients served globally" },
        { value: 300, label: "Projects delivered" },
        { value: 8, label: "Countries with operations" },
        { value: 15, label: "Industries" },
    ];

    return (
        <>

            {/* <section id="home" style={{ backgroundImage: `url(${homebg})` }}>
                <HomeHeader />
            </section> */}


            <HomeHeader />


            <section className="container my-5 who-section">
                <div className="row align-items-center">
                    {/* <motion.div
                        className="col-12 col-md-7 mb-4 mb-md-0"
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.6 }}
                    > */}
                    <div className="col-12 col-md-7 mb-4 mb-md-0">
                        <h2 className="fw-bold display-5">
                            <span className="highlight-orange">Who</span> we <span className="highlight-orange">are?</span>
                        </h2>
                        <p className="lead mt-3">
                            Peregrinee is a new-age IT and digital transformation agency where we specialize in building AI-powered products, scalable software solutions, and transformative digital marketing strategies tailored for global B2B brands. We serve clients globally, including countries like India, the USA, UAE, Saudi Arabia, Qatar, Oman, Egypt, the UK, Singapore, and Germany, and across industries such as manufacturing, healthcare, education, retail, logistics, real estate, and technology. Our diverse team includes Mobile Developers (iOS and Android), Frontend Web Developers, Backend Developers, Full Stack Developers, AI & Data Analytics Engineers, Gaming Developers, DevOps Engineers, UI/UX Designers, Researchers, QA Engineers, Business Analysts, Product Owners, Scrum Masters, Delivery Managers, and Copywriters/Content Managers — bringing a mix of expertise and experience to every project. Combining deep-rooted industry experience with cutting-edge technology, we empower businesses to evolve, grow, and lead in a rapidly changing digital world.
                        </p>
                    </div>

                    {/* <motion.div
                        className="col-12 col-md-5 text-center mt-4 mt-md-0"
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.6 }}
                    > */}
                        <div className="col-12 col-md-5 text-center mt-4 mt-md-0">
                        <img
                            src={whoImg}
                            alt="Descriptive Alt Text"
                            className="img-fluid rounded section-image"
                            style={{ maxHeight: '500px' }}
                        />
                    </div>
                </div>
            </section>



            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading-first">
                        <span className="highlight-orange">Trusted By 350+</span> Global Enterprises to solve their biggest <span className="highlight-orange">software challenges</span>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-4">
                    <a
                        href="/contact-us"
                        className="btn custom-orange-btn py-3 px-4 fw-bold"
                    >
                        Get in Touch With Us
                    </a>
                </div>
            </motion.section>

            <section className="container my-5">
                <motion.div
                    className="row justify-content-center align-items-center"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                >
                    {[
                        cTOne, cTTwo, cTThree, cTFour,
                        cTFive, cTSix, cTSeven, cTEight
                    ].map((imgSrc, idx) => (
                        <motion.div
                            className="col-6 col-md-3 text-center"
                            key={idx}
                            whileHover={{ scale: 1.3 }}
                            transition={{ type: 'spring', stiffness: 300 }}
                        >
                            <img
                                src={imgSrc}
                                alt={`Client ${idx + 1}`}
                                className="img-fluid p-2"
                                style={{
                                    maxHeight: idx === 1 ? '60px' : idx === 6 ? '150px' : '120px',
                                    width: idx === 6 ? '110%' : 'auto',
                                    objectFit: 'contain',
                                    display: 'inline-block'
                                }}
                            />
                        </motion.div>
                    ))}

                </motion.div>
            </section>

            <section id="services" className="services-section" style={{ backgroundImage: `url(${servicebg})` }}>
                <motion.section className="container my-5"
                    initial={{ y: 30, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true, amount: 0.6 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}>
                    <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                        <div className="px-3 fw-bold responsive-heading"><span className="highlight-orange">Services</span>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                        <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                            We ideate, strategize, design, and develop <span className="highlight-orange">digital solutions </span> that accelerate <span className="highlight-orange"> digital transformation </span>across various industries.
                        </span>
                    </div>
                    {/* <div className="d-flex justify-content-center mt-4">
                        <a
                            href="#contact-us"
                            className="btn custom-orange-btn py-3 px-4 fw-bold"
                        >
                            Get in Touch With Us
                        </a>
                    </div> */}
                </motion.section>
                <div className="container my-5">
                    <div className="row">
                        {services.map(({ Icon, title, desc, link }, idx) => (
                            <motion.div
                                key={idx}
                                className="col-12 col-sm-6 col-md-3 mb-4"
                                initial={{ x: idx < 4 ? -50 : 50, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                viewport={{ once: true, amount: 0.5 }}
                                transition={{ duration: 0.8, ease: 'easeOut', delay: idx * 0.2 }}
                                style={{ cursor: 'pointer' }}
                                onClick={() => window.open(link, '_blank')}
                            >
                                <div className="services-card">
                                    <Icon size={48} className="services-icon" />
                                    <h5 className="fw-bold mb-2">{title}</h5>
                                    <p className="mb-0" style={{ fontSize: '14px' }}>
                                        {desc}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>

            </section>

            <motion.section id="industries" className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}>
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div
                        className="px-3 fw-bold responsive-heading"
                    >
                        <span className="highlight-orange">Industries</span>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                        <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                            Our comprehensive offshore <span className="highlight-orange">software development </span> services cover a wide range of <span className="highlight-orange">industries and sectors. </span>
                        </span>
                    </div>
                </div>
                {/* <div className="d-flex justify-content-center mt-4">
                    <a
                        href="#contact-us"
                        className="btn custom-orange-btn py-3 px-4 fw-bold"
                    >
                        Get in Touch With Us
                    </a>
                </div> */}
            </motion.section>

            <section className="container my-5">
                {/* Buttons */}
                <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            className={`btn fw-bold px-4 py-2 ${activeTab === index ? 'active-tab' : 'inactive-tab'}`}
                            onClick={() => setActiveTab(index)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* Tab Content Layout */}
                <motion.div
                    className="row g-4 align-items-center shadow rounded bg-white p-4"
                    key={activeTab} // triggers re-animation on tab change
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}>
                    {/* Left: Title & Text */}
                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <motion.h4
                            className="fw-bold"
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}>
                            {tabContents[activeTab].title}
                        </motion.h4>
                        <motion.p
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8, delay: 0.1 }}>
                            {tabContents[activeTab].text}
                        </motion.p>
                    </div>

                    {/* Right: Image */}
                    <motion.div
                        className="col-12 col-md-6"
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1, delay: 0.2 }}>
                        <img
                            src={tabContents[activeTab].img}
                            alt="Media & communication industry"
                            className="img-fluid w-100 h-100 object-fit-cover rounded"
                            style={{ objectFit: 'cover' }}
                        />
                    </motion.div>
                </motion.div>
            </section>

            <section id="tech-stack" className="tech-section" style={{ backgroundImage: `url(${servicebg})` }}>
                <motion.section className="container my-5"
                    initial={{ y: 30, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true, amount: 0.6 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}>
                    <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                        <div className="px-3 fw-bold responsive-heading">Technologies We <span className="highlight-orange">Root</span> For
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                        <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                            Your Business Partners to Navigate the <span className="highlight-orange">Digital Landscape  </span> with   <span className="highlight-orange"> Latest Technology </span>
                        </span>
                    </div>
                    {/* <div className="d-flex justify-content-center mt-4">
                        <a
                            href="#contact-us"
                            className="btn custom-orange-btn py-3 px-4 fw-bold"
                        >
                            Get in Touch With Us
                        </a>
                    </div> */}
                </motion.section>

                <div className="container my-5">
                    <motion.img
                        src={techStack}
                        alt="Descriptive alt text"
                        className="img-fluid rounded w-100"
                        style={{ objectFit: 'cover' }}
                        initial={{ y: 30, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        viewport={{ once: true, amount: 0.6 }}
                        transition={{ duration: 0.8, ease: "easeOut" }} />
                </div>
            </section>

            <motion.section className="container my-5 verified-reviews"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading-first">Our
                        <span className="highlight-orange"> Verified Reviews </span> From <span className="highlight-orange">Different</span>  Platforms
                    </div>
                </div>
            </motion.section>

            <section className="container my-5">
                <motion.div
                    className="row justify-content-center align-items-center"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                >
                    {reviews.map((item, idx) => (
                        <motion.div
                            className="col-6 col-md-3 mb-4 text-center"
                            key={idx}
                            whileHover={{ scale: 1.3 }}
                            transition={{ type: 'spring', stiffness: 300 }}
                        >
                            <a href={item.link} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={item.src}
                                    alt={`Client ${idx + 1}`}
                                    className="img-fluid p-2"
                                    style={{
                                        maxHeight: idx === 1 ? '90px' : idx === 6 ? '150px' : '120px',
                                        width: idx === 6 ? '110%' : 'auto',
                                        objectFit: 'contain',
                                        display: 'inline-block'
                                    }}
                                />
                            </a>
                        </motion.div>
                    ))}

                </motion.div>
            </section>

            <section id="case-study" className="container my-5">
                <motion.section className="container my-5"
                    initial={{ y: 30, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true, amount: 0.6 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}>
                    <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                        <div className="px-3 fw-bold responsive-heading">Case <span className="highlight-orange">Study</span>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                        <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                            We leverage <span className="highlight-orange">next-gen technologies </span> for our   <span className="highlight-orange">clients </span> across industries.
                        </span>
                    </div>
                    {/* <div className="d-flex justify-content-center mt-4">
                        <a
                            href="/contact-us"
                            className="btn custom-orange-btn py-2 px-3 fw-bold"
                        >
                            View More
                        </a>
                    </div> */}
                </motion.section>

            </section>

            <section className="container my-5">
                <div className="row g-4">
                    {features.map((feature, index) => (
                        <div className="col-12 col-md-4" key={feature.id}>
                            <Link to={feature.link} style={{ textDecoration: 'none' }}>
                                <motion.div
                                    className="image-box position-relative overflow-hidden rounded shadow-sm hover-trigger"
                                    initial={feature.animation.initial}
                                    whileInView={feature.animation.animate}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: feature.animation.delay }}
                                    viewport={{ once: true, amount: 0.3 }}
                                >
                                    <img
                                        src={feature.image}
                                        alt={feature.alt}
                                        className="img-fluid w-100 h-100 object-fit-cover" />
                                    <div className="overlay-box position-absolute bottom-0 start-0 w-100 text-white p-3">
                                        <motion.div
                                            className="icon-circle position-absolute"
                                            whileHover={{ scale: 1.2 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <FaArrowRight />
                                        </motion.div>
                                        <h5 className="mb-2">{feature.title}</h5>
                                        <p className="placeholder-text m-0">{feature.description}</p>
                                    </div>
                                </motion.div>
                            </Link>
                        </div>
                    ))}
                </div>
            </section>
            <br />

            <ClientReviews />

            <BlogSection />

            <section className="container my-5 peregrinee-section text-dark py-5 px-3 ">
                <div className="row align-items-center gy-5">

                    {/* Left Content */}
                    <div className="col-md-6">
                        <h2 className="peregrinee-heading mb-4">
                            Peregrinee
                        </h2>
                        <p className="fs-5">
                            We believe in human potential and invest heavily in the capabilities of new generations by practically teaching them about emerging technologies.
                        </p>

                        {/* Stats Grid */}
                        <div className="row mt-4">
                            {stats.map((stat, i) => (
                                <div key={i} className="col-6 mb-4">
                                    <div className="fs-2 fw-bold text-dark">
                                        {counters[i]}
                                        {stat.value > 10 ? '+' : ''}
                                    </div>
                                    <div className="fs-6 fw-semibold text-secondary">{stat.label}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Image with Gradient Background */}
                    <div className="col-md-6 position-relative">
                        <div className="gradient-bg position-absolute w-100 h-100 rounded-4"></div>
                        <img
                            src={downSection}
                            alt="Peregrinee"
                            className="img-fluid rounded-4 position-relative mt-4 hover-scale"
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </div>
            </section>
            <br />


        </>
    );
}

export default Home;
